import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.colors.white,
    overflow: 'auto',
    [theme.breakpoints.up('mobile')]: {
      height: 'unset',
    },
  },
  header: {
    width: '100%',
    height: 64,
    display: 'flex',
    alignItems: 'center',
    borderBottom: [1, 'solid', theme.palette.colors.divider],
    justifyContent: 'center',
    [theme.breakpoints.up('mobile')]: {
      minWidth: 700,
      maxWidth: 1420,
      margin: [theme.spacing(7), 'auto', 0],
      padding: [0, 20],
      fontSize: 32,
      justifyContent: 'flex-start',
      borderBottom: 'none',
      height: '100%',
    },
  },
  content: {
    margin: [0, theme.spacing(4)],
    height: '100%',
    [theme.breakpoints.up('mobile')]: {
      minWidth: 700,
      width: '100%',
      maxWidth: 1420,
      margin: [0, 'auto'],
      padding: [0, 20, theme.spacing(7)],
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/useStyles.js